import React, { Component } from 'react';
import PlaceholderWinsIllustration from './../../assets/placeholders/weekly_wins_placeholder.svg';

class PlaceholderObjectivesActions extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      status:this.props.status?this.props.status:false
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    if(this.props.status!== prevProps.status){
      this.setState({status: this.props.status})
    }
  }

  render() { 
    let {status}=this.state
    let statusTxt
    if(status=='P'){
      statusTxt='There are no actions in progress for this Enterprise Objective.'
    } else if(status=='I'){
      statusTxt='There are no actions that are not started for this Enterprise Objective.'
    }else if(status=='C'){
      statusTxt='There are no completed actions for this Enterprise Objective.'
    }else if(status=='O'){
      statusTxt='There are no actions that are past due for this Enterprise Objective.'
    } else {
      statusTxt='There are '
    }
    return ( 
      <div className="weekly-wins-placeholder">
        <img style={{width:'145px'}} src={PlaceholderWinsIllustration}/>
        <div className="subheader mt20">  
        
        { status!='A'?
            <span>
              {statusTxt}
            </span>
            :
            <span>
              {/* Your organization has not created any Actions yet. Once created, you will be able to assign them, add a due date, show progress, 
              and see metrics associated with your actions. */}

              There are no actions linked with this Enterprise Objective yet. 
              You can link your own action(s) on the 
              <span className="navLink" onClick={() => this.props.history.push('/home/my-activity')}> My Actions</span> page. 
            </span>
          }
        
        </div>
      </div>
    );
  }
}
 
export default PlaceholderObjectivesActions;